import * as React from "react";
import styled from "styled-components";
import { RowContentStyles } from "components/bootstrap/Row";
const Container = styled.div`
  z-index: auto;
  ${RowContentStyles}
  margin-bottom: 0;
`;
const WidgetContainer = ({ children = void 0, className = void 0, isFocused, style = {}, ...rest }, ref) => {
  let containerStyle = {
    ...style,
    transition: "none"
  };
  if (isFocused) {
    containerStyle = {
      ...containerStyle,
      height: "100%",
      width: "100%",
      zIndex: 3,
      top: 0,
      left: 0
    };
  }
  return /* @__PURE__ */ React.createElement(Container, { className, style: containerStyle, ref, ...rest }, children);
};
export default React.forwardRef(WidgetContainer);
